import { useMemo } from "react";
import Select from "react-select";
import { formatTime12 } from "./rosterUtils";

export default function WfShiftSelect({ shifts, value, onChange, disabled, placeholder }) {
  const options = useMemo(
    () =>
      (shifts || []).map((s) => ({
        value: s.shift_id,
        label: s.name,
        sub: `${formatTime12(s.start_time)} – ${formatTime12(s.end_time)} · Break ${s.break_minutes || 0} min`,
        raw: s,
      })),
    [shifts]
  );

  const selected = options.find((o) => o.value === value) || null;

  const formatOptionLabel = (opt) => (
    <div>
      <div className="text-sm font-medium">{opt.label}</div>
      <div className="text-xs text-gray-500">{opt.sub}</div>
    </div>
  );

  return (
    <Select
      options={options}
      value={selected}
      onChange={(opt) => {
        const id = opt?.raw?.shift_id ?? opt?.value ?? "";
        onChange(id ? String(id) : "", opt?.raw);
      }}
      isDisabled={disabled}
      placeholder={placeholder || "Select shift…"}
      formatOptionLabel={formatOptionLabel}
      classNamePrefix="wf-select"
      styles={{
        control: (base) => ({
          ...base,
          minHeight: 42,
          borderRadius: 8,
          borderColor: "#d1d5db",
        }),
      }}
    />
  );
}
